import { render, staticRenderFns } from "./CartFamilyDiscount.vue?vue&type=template&id=21dbf3a1&"
import script from "./CartFamilyDiscount.vue?vue&type=script&lang=js&"
export * from "./CartFamilyDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports